<template>
  <div>
    <c-list
      :data="cList.items"
      :columns="cList.columns"
      :total="cList.total"
      :page-size="1000"
      :page-current="listPageCurrent"
      :search-where="listSearchWhere"
      @selection-change="handleListSelectionChange"
    >
      <c-list-header>
        <c-list-operations>
          <Button @click="$helpers.goBack()">返回</Button>
        </c-list-operations>
      </c-list-header>
    </c-list>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import ListMixin from "view-ui-admin/src/mixins/list";
import Model from "@/models/admin/courses";

@Component({
  mixins: [RouteParamsMixin, ListMixin]
})
export default class extends Vue {
  data() {
    return {
      cList: {
        items: [],
        total: 0,
        columns: [
          {
            title: "班级",
            render: (h, { row }) => h("span", null, row.className)
          },
          {
            title: "教师",
            render: (h, { row }) => h("span", null, row.teacherName)
          },
          {
            title: "学员",
            key: "name"
          },
          {
            title: "正常",
            key: "normalCount"
          },
          {
            title: "迟到",
            key: "lateCount"
          },
          {
            title: "请假",
            key: "leaveCount"
          },
          {
            title: "已用课时/总课时",
            render: (h, { row }) =>
              h("span", null, `${row.usedClassHours}/${row.classHours}`)
          }
        ]
      }
    };
  }

  async created() {
    await this.getList();
  }

  async getList() {
    const {
      data: { items, total }
    } = await new Model().addPath("getClassSignIns").POST({
      body: {
        classId: this.$route.params.classId
      }
    });

    this.cList.items = items;
    this.cList.total = total;
  }
}
</script>
